import React from 'react'
import './Banner.css'
import { Button } from '@mui/material'
import SendIcon from '@mui/icons-material/Send';
import { useNavigate } from 'react-router-dom';

function Banner(props) {
    const navigate = useNavigate();
    return (
        <>
            <div className='banner'>
                <img src='images/inner_bg.jpg' className='img-fluid' alt="CarGenie" />
                <div className='bannerContainer'>
                    <div className='container'>
                        <h1>{props.pageName}</h1>
                        <Button
                            variant="contained"
                            color="secondary"
                            className='roundedBox buttonBlue'
                            endIcon={<SendIcon />}
                            onClick={() => navigate('/services')}
                        > Book A Service </Button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Banner